import "./Home.css";

// HERO IMAGE
import heroImage from "../../assets/hero.jpg";

// PROJECT IMAGES
import kitchenImg from "../../assets/kitchen.jpg";
import livingImg from "../../assets/living.jpg";
import bedroomImg from "../../assets/bedroom.jpg";
import wardrobeImg from "../../assets/wardrobe.jpg";

export default function Home() {
  return (
    <>
      {/* ================= HERO ================= */}
      <section
        className="home-hero"
        style={{
          backgroundImage: `linear-gradient(
            rgba(0,0,0,0.45),
            rgba(0,0,0,0.45)
          ), url(${heroImage})`,
        }}
      >
        <div className="home-hero-content">
          <h1>Elvara Signatures</h1>
          <p>Premium Modular & Interior Solutions</p>

          <div className="home-buttons">
            <button className="btn-primary">View Projects</button>
            <button className="btn-outline">Contact Us</button>
          </div>
        </div>
      </section>

      {/* ================= WHAT WE DO ================= */}
      <section className="what-we-do">
        <h2>What We Do</h2>

        <div className="services-grid">
          <div className="service-card">
            <h3>Modular Kitchens</h3>
            <p>Elegant, functional kitchen designs.</p>
          </div>

          <div className="service-card">
            <h3>Wardrobes & Storage</h3>
            <p>Smart storage with premium finishes.</p>
          </div>

          <div className="service-card">
            <h3>Electrical & Integration</h3>
            <p>Clean wiring & smart solutions.</p>
          </div>

          <div className="service-card">
            <h3>Complete Interiors</h3>
            <p>End-to-end interior execution.</p>
          </div>
        </div>
      </section>

      {/* ================= WHY ELVARA ================= */}
      <section className="why-elvara">
        <h2>Why Elvara Signatures</h2>

        <div className="projects-grid">
          <div className="project-card">
            <img src={kitchenImg} alt="Modern Kitchen" />
            <h4>Modern Kitchens</h4>
            <span>Completed Project</span>
          </div>

          <div className="project-card">
            <img src={livingImg} alt="Luxury Living Room" />
            <h4>Luxury Living Room</h4>
            <span>Completed Project</span>
          </div>

          <div className="project-card">
            <img src={bedroomImg} alt="Stylish Bedroom" />
            <h4>Stylish Bedroom</h4>
            <span>Completed Project</span>
          </div>

          <div className="project-card">
            <img src={wardrobeImg} alt="Elegant Wardrobe" />
            <h4>Elegant Wardrobe</h4>
            <span>Completed Project</span>
          </div>
        </div>
      </section>

      {/* ================= CTA ================= */}
      <section className="cta-section">
        <h2>Let’s Discuss Your Project</h2>
        <button className="btn-primary">Get In Touch</button>
      </section>
    </>
  );
}